import type { CartItemType } from '@/store/types/cart'
import type { GlobalStoreValues } from '@/store/useGlobalStore'
import { getTerms } from '../../services/useGetTerms'

type Props = {
  globalStore: GlobalStoreValues
  cart: CartItemType[]
  event_location?: string
}

export const getEcommerceObjectForAddToCart = ({
  globalStore,
  cart,
  event_location,
}: Props) => {
  const {
    user: { customerType },
    app: { marketExceptions },
  } = globalStore

  const getCartTotal = () =>
    cart.reduce(
      (accumulator, item) =>
        accumulator +
        (getTerms({
          forCustomerType: customerType,
          pricingData: item.product.pricing,
        })?.priceEach || 0) *
          item.qty,
      0,
    )

  const getItems = (cartItems: CartItemType[]) =>
    cartItems.map((item) => ({
      item_brand: 'Unicity',
      discount: item.subscriptionDiscount,
      item_id: item.product.sku,
      item_variant: item.product.combinationName,
      item_category: '', // TODO: Add category to the cart values
      ship_by: '', // TODO: Figure out a way to get the ship by in the cart
      purchase_type: item.po === 'otp' ? 'one-time-purchase' : item.po,
      item_name: item.title,
      price: getTerms({
        forCustomerType: customerType,
        pricingData: item.product.pricing,
      })?.priceEach,
      quantity: item.qty,
      item_list_name: event_location,
      item_list_id: event_location,
    }))

  return {
    currency: marketExceptions?.currencyCode,
    value: getCartTotal(),
    items: [...getItems(cart)],
  }
}
